import { render, staticRenderFns } from "./Msg.vue?vue&type=template&id=5f9c2be3&scoped=true&"
import script from "./Msg.vue?vue&type=script&lang=js&"
export * from "./Msg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9c2be3",
  null
  
)

export default component.exports